// GENERATED from registry/stars-notable.yaml by scripts/gen_stars_notable_js.py. Do not edit.
//
// `python3 scripts/gen_stars_notable_js.py --check` fails CI if this file and the YAML disagree, so
// an edit here is an edit that will be reverted. Change the YAML.
//
// scene/stars3d.js merges each row into the star record it names (`hip-<hip>`, or the HYG row with
// that exact proper name when there is no HIP number): `why` makes the star notable to ui/labels.js
// and is the line ui/cards.js prints under the first sentence; `name` becomes the record's name
// where the names file says something else, and the old one stays as an alias for search.

/** Famous stars, one line each on why, with the page it was read from. */
export const STARS_NOTABLE = [
  {
    "hip": 70890,
    "name": "Proxima Centauri",
    "why": "The nearest star to the Sun, a red dwarf too faint to see without a telescope. Its planet Proxima b, found in 2016, orbits in its habitable zone.",
    "source": "https://en.wikipedia.org/wiki/Proxima_Centauri (read 2026-09-22)",
    "radius_suns": 0.141,
    "radius_err_suns": 0.007,
    "teff_k": 3054,
    "teff_err_k": 79,
    "physical_source": "https://arxiv.org/abs/1208.2431 (read 2026-10-09)"
  },
  {
    "hip": 71683,
    "name": "Alpha Centauri A",
    "why": "The larger of the nearest pair of stars to the Sun, 1.1 times the Sun's mass. To the eye, it and B are one star, the third-brightest in the sky.",
    "source": "https://en.wikipedia.org/wiki/Alpha_Centauri (read 2026-09-22)",
    "radius_suns": 1.224,
    "radius_err_suns": 0.003,
    "physical_source": "https://arxiv.org/abs/astro-ph/0303634 (read 2026-10-09)"
  },
  {
    "hip": 71681,
    "name": "Alpha Centauri B",
    "why": "The orange half of the nearest pair of stars to the Sun. It and Alpha Centauri A go round each other once every 79 years.",
    "source": "https://en.wikipedia.org/wiki/Alpha_Centauri (read 2026-09-22)",
    "radius_suns": 0.863,
    "radius_err_suns": 0.005,
    "physical_source": "https://arxiv.org/abs/astro-ph/0303634 (read 2026-10-09)"
  },
  {
    "hip": 87937,
    "name": "Barnard's Star",
    "why": "It crosses the sky faster than any other star, 10.3 arcseconds a year. Four small planets were found around it in 2024 and 2025.",
    "source": "https://en.wikipedia.org/wiki/Barnard%27s_Star (read 2026-09-22)",
    "radius_suns": 0.1869,
    "radius_err_suns": 0.0012,
    "teff_k": 3222,
    "teff_err_k": 10,
    "physical_source": "https://arxiv.org/abs/1208.2431 (read 2026-10-09)"
  },
  {
    "proper": "Wolf 359",
    "name": "Wolf 359",
    "why": "A red dwarf so faint it takes a large telescope, yet only Alpha Centauri, Barnard's Star and two brown dwarfs are nearer. Star Trek set a battle here.",
    "source": "https://en.wikipedia.org/wiki/Wolf_359 (read 2026-09-22)"
  },
  {
    "hip": 32349,
    "name": "Sirius",
    "why": "The brightest star in the night sky, almost twice as bright as Canopus, the next. A faint white dwarf, Sirius B, circles it.",
    "source": "https://en.wikipedia.org/wiki/Sirius (read 2026-09-22)",
    "radius_suns": 1.713,
    "radius_err_suns": 0.009,
    "teff_k": 9845,
    "teff_err_k": 64,
    "physical_source": "https://arxiv.org/abs/1010.3790 (read 2026-10-09)"
  },
  {
    "hip": 16537,
    "name": "Epsilon Eridani",
    "why": "The third-closest star you can see with the naked eye, with a giant planet and a dust belt like our Kuiper belt. Project Ozma listened to it in 1960.",
    "source": "https://en.wikipedia.org/wiki/Epsilon_Eridani (read 2026-09-22)",
    "radius_suns": 0.735,
    "radius_err_suns": 0.005,
    "teff_k": 5077,
    "teff_err_k": 35,
    "physical_source": "https://arxiv.org/abs/1208.2431 (read 2026-10-09)"
  },
  {
    "hip": 104214,
    "name": "61 Cygni A",
    "why": "The first star after the Sun to have its distance measured, by Friedrich Bessel in 1838. It moves so fast across the sky it was called the Flying Star.",
    "source": "https://en.wikipedia.org/wiki/61_Cygni (read 2026-09-22)",
    "radius_suns": 0.6611,
    "radius_err_suns": 0.0048,
    "teff_k": 4361,
    "teff_err_k": 17,
    "physical_source": "https://arxiv.org/abs/1208.2431 (read 2026-10-09)"
  },
  {
    "hip": 37279,
    "name": "Procyon",
    "why": "Its name means 'before the dog': it crosses the sky just ahead of Sirius, the Dog Star. Like Sirius, it has a white dwarf companion.",
    "source": "https://en.wikipedia.org/wiki/Procyon (read 2026-09-22)",
    "radius_suns": 2.048,
    "radius_err_suns": 0.025,
    "physical_source": "https://arxiv.org/abs/astro-ph/0312068 (read 2026-10-09)"
  },
  {
    "hip": 8102,
    "name": "Tau Ceti",
    "why": "The closest solitary Sun-like star. In 1960 Project Ozma, the first modern search for alien radio signals, listened to it and heard nothing.",
    "source": "https://en.wikipedia.org/wiki/Tau_Ceti (read 2026-09-22) and https://en.wikipedia.org/wiki/Project_Ozma (read 2026-09-22)"
  },
  {
    "hip": 24186,
    "name": "Kapteyn's Star",
    "why": "The nearest halo star: about 11 billion years old, going round the galaxy the wrong way. It may once have belonged to Omega Centauri.",
    "source": "https://en.wikipedia.org/wiki/Kapteyn%27s_Star (read 2026-09-22)"
  },
  {
    "hip": 3829,
    "name": "Van Maanen's Star",
    "why": "The nearest lone white dwarf. A 1917 photograph of its spectrum holds the earliest known evidence of planetary matter outside the Solar System.",
    "source": "https://en.wikipedia.org/wiki/Van_Maanen_2 (read 2026-09-22)"
  },
  {
    "hip": 30438,
    "name": "Canopus",
    "why": "The second-brightest star in the night sky. Spacecraft steer by it: in 1964 Mariner 4 locked on to it, the first time a star had been used.",
    "source": "https://en.wikipedia.org/wiki/Canopus (read 2026-09-22)"
  },
  {
    "hip": 69673,
    "name": "Arcturus",
    "why": "The brightest star in the northern half of the sky, a red giant 25 times the Sun's size. Its light opened the 1933 Chicago World's Fair.",
    "source": "https://en.wikipedia.org/wiki/Arcturus (read 2026-09-22)",
    "radius_suns": 25.4,
    "radius_err_suns": 0.2,
    "teff_k": 4286,
    "teff_err_k": 30,
    "physical_source": "https://arxiv.org/abs/1109.4425 (read 2026-10-09)"
  },
  {
    "hip": 91262,
    "name": "Vega",
    "why": "The first star after the Sun to be photographed, and the star the brightness scale was calibrated on. It was the pole star around 12 000 BCE.",
    "source": "https://en.wikipedia.org/wiki/Vega (read 2026-09-22)"
  },
  {
    "hip": 24608,
    "name": "Capella",
    "why": "The sixth-brightest star in the sky looks like one star and is four, in two pairs. The bright pair are yellow giants of about 2.5 Suns each.",
    "source": "https://en.wikipedia.org/wiki/Capella (read 2026-10-11)",
    "radius_suns": 11.98,
    "radius_err_suns": 0.57,
    "teff_k": 4970,
    "teff_err_k": 50,
    "physical_source": "https://arxiv.org/abs/1505.07461 (read 2026-10-11)"
  },
  {
    "hip": 24436,
    "name": "Rigel",
    "why": "The brightest star in Orion and usually the seventh-brightest in the sky: a blue supergiant around 120 000 times as luminous as the Sun.",
    "source": "https://en.wikipedia.org/wiki/Rigel (read 2026-09-22)"
  },
  {
    "hip": 7588,
    "name": "Achernar",
    "why": "It spins so fast it is 35% wider at the equator than pole to pole: in 2015, the least spherical star known in the Milky Way.",
    "source": "https://en.wikipedia.org/wiki/Achernar (read 2026-09-22)"
  },
  {
    "hip": 97649,
    "name": "Altair",
    "why": "It spins in under eight hours and bulges over 20% at its equator. The first main-sequence star after the Sun to have its surface imaged.",
    "source": "https://en.wikipedia.org/wiki/Altair (read 2026-09-22)"
  },
  {
    "hip": 21421,
    "name": "Aldebaran",
    "why": "The eye of Taurus, a red giant 45 times as wide as the Sun. It lies in line with the Hyades cluster but is unrelated. Pioneer 10 is heading its way.",
    "source": "https://en.wikipedia.org/wiki/Aldebaran (read 2026-09-22)"
  },
  {
    "hip": 65474,
    "name": "Spica",
    "why": "Two hot stars so close they orbit every four days and pull each other out of round. Hipparchus is believed to have found precession from its position.",
    "source": "https://en.wikipedia.org/wiki/Spica (read 2026-09-22)"
  },
  {
    "hip": 80763,
    "name": "Antares",
    "why": "A red supergiant so big that, put in the Sun's place, it would reach into the asteroid belt. Its name means rival to Ares, for its Mars-red colour.",
    "source": "https://en.wikipedia.org/wiki/Antares (read 2026-09-22)"
  },
  {
    "hip": 37826,
    "name": "Pollux",
    "why": "The closest giant star to the Sun, and the brightest star in Gemini. A planet, Thestias, was announced around it in 2006.",
    "source": "https://en.wikipedia.org/wiki/Pollux_(star) (read 2026-09-22)"
  },
  {
    "hip": 113368,
    "name": "Fomalhaut",
    "why": "Ringed by a disc of debris. The 'planet' photographed inside it in 2008 turned out to be an expanding cloud from a collision.",
    "source": "https://en.wikipedia.org/wiki/Fomalhaut (read 2026-09-22)"
  },
  {
    "hip": 102098,
    "name": "Deneb",
    "why": "The most distant of the thirty brightest stars and one of the most luminous. Estimates of how far away it is differ by nearly two to one.",
    "source": "https://en.wikipedia.org/wiki/Deneb (read 2026-09-22)",
    "radius_suns": 203,
    "radius_err_suns": 17,
    "teff_k": 8525,
    "teff_err_k": 75,
    "physical_source": "https://arxiv.org/abs/0712.0040 (read 2026-10-09)"
  },
  {
    "hip": 49669,
    "name": "Regulus",
    "why": "The closest bright star to the ecliptic, so the Moon often passes in front of it. It spins every 15.9 hours, near the speed that would tear it apart.",
    "source": "https://en.wikipedia.org/wiki/Regulus (read 2026-09-22)"
  },
  {
    "hip": 60718,
    "name": "Acrux",
    "why": "The brightest star of the Southern Cross, which flies on the flags of Australia, New Zealand, Samoa, Papua New Guinea and Brazil.",
    "source": "https://en.wikipedia.org/wiki/Acrux (read 2026-09-22)"
  },
  {
    "hip": 36850,
    "name": "Castor",
    "why": "One point of light, six stars in three pairs. It was first recorded as a double star in 1718.",
    "source": "https://en.wikipedia.org/wiki/Castor_(star) (read 2026-09-22)"
  },
  {
    "hip": 11767,
    "name": "Polaris",
    "why": "The North Star: it sits less than a degree from the north celestial pole, so the northern sky turns around it. It is three stars, not one.",
    "source": "https://en.wikipedia.org/wiki/Polaris (read 2026-09-22)"
  },
  {
    "hip": 68756,
    "name": "Thuban",
    "why": "The North Star of the 4th to 2nd millennium BC. In 2830 BC it sat less than 10 arcminutes from the pole of the sky.",
    "source": "https://en.wikipedia.org/wiki/Thuban (read 2026-09-22)"
  },
  {
    "hip": 116727,
    "name": "Gamma Cephei",
    "why": "Its planet, proposed in 1988, doubted, and confirmed in 2002, was the first ever discovered. From about 3157 CE it replaces Polaris as the pole star.",
    "source": "https://en.wikipedia.org/wiki/Gamma_Cephei (read 2026-09-22)"
  },
  {
    "hip": 10826,
    "name": "Mira",
    "why": "Latin for 'wonderful': every 332 days or so it brightens to naked-eye view, then fades out of sight. It was recorded changing in 1596.",
    "source": "https://en.wikipedia.org/wiki/Mira (read 2026-09-22)"
  },
  {
    "hip": 14576,
    "name": "Algol",
    "why": "The Demon Star. Every 2 days 20 hours 49 minutes its companion passes in front of it and it dims for about ten hours.",
    "source": "https://en.wikipedia.org/wiki/Algol (read 2026-09-22)"
  },
  {
    "hip": 110991,
    "name": "Delta Cephei",
    "why": "The prototype Cepheid, pulsing every 5.37 days. A Cepheid's period tells its true brightness, and this star helps calibrate that rule.",
    "source": "https://en.wikipedia.org/wiki/Delta_Cephei (read 2026-09-22)"
  },
  {
    "hip": 23416,
    "name": "Epsilon Aurigae",
    "why": "Every 27 years something dark covers it for about two years, thought to be a dusty disc around a hidden star. The last time was 2009 to 2011.",
    "source": "https://en.wikipedia.org/wiki/Epsilon_Aurigae (read 2026-09-22)"
  },
  {
    "hip": 65378,
    "name": "Mizar",
    "why": "With Alcor beside it, a test of eyesight. Galileo recorded it as a double in 1617, and Mizar A was the first spectroscopic binary found.",
    "source": "https://en.wikipedia.org/wiki/Mizar (read 2026-09-22)"
  },
  {
    "hip": 95947,
    "name": "Albireo",
    "why": "An amber star and a blue-green one side by side in a small telescope. Whether they orbit each other or only line up is still not known.",
    "source": "https://en.wikipedia.org/wiki/Albireo (read 2026-09-22)"
  },
  {
    "hip": 79672,
    "name": "18 Scorpii",
    "why": "A near twin of the Sun, a little younger, and bright enough to see without a telescope from a dark site.",
    "source": "https://en.wikipedia.org/wiki/18_Scorpii (read 2026-09-22)"
  },
  {
    "hip": 113357,
    "name": "51 Pegasi",
    "why": "The first Sun-like star found with a planet, in 1995: a hot Jupiter going round it every four days. Its finders shared the 2019 Nobel Prize in Physics.",
    "source": "https://en.wikipedia.org/wiki/51_Pegasi (read 2026-09-22) and https://en.wikipedia.org/wiki/51_Pegasi_b (read 2026-09-22)"
  },
  {
    "hip": 7513,
    "name": "Upsilon Andromedae",
    "why": "The first main-sequence star found with more than one planet, and the first planetary system known in a system of more than one star.",
    "source": "https://en.wikipedia.org/wiki/Upsilon_Andromedae (read 2026-09-22)"
  },
  {
    "hip": 27321,
    "name": "Beta Pictoris",
    "why": "The first star whose disc of debris was photographed, in 1984. It is only about 23 million years old, and both of its known planets have been imaged.",
    "source": "https://en.wikipedia.org/wiki/Beta_Pictoris (read 2026-09-22)"
  }
];
